<template>
  <div
    class="video-player"
    ref="videoPlayer"
    @click="playVideoClick"
    @mousemove="handleOverlay"
  >
    <div
      class="flat-btn play-btn"
      ref="playVideo"
    >
      <i class="fas fa-play"></i>
    </div>
    <div class="spinner-holder" ref="spinner">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="video-block">
      <video
        class="video"
        @click="handlePlayPause"
        ref="player"
        @canplay="updateVideoInfo"
        @timeupdate="updateVideoInfo"
        autoplay
        preload
        loop
        :src="url"
      ></video>
      <nav class="navbar" ref="navbar">
        <input
          class="video-range"
          v-model="videoRangeValue"
          @input="videoSelect"
          type="range"
          min="0"
          max="100"
          step="0.001"
          :style="{
            background: `linear-gradient(to right, #ffffff 0% , #ffffff ${
              videoRangeValue == null ? 0 : videoRangeValue
            }%  , #595959 0%, #595959 100%)`,
          }"
        />
        <div class="nav-btn">
          <span>
            <button class="stop-pause" @click="handlePlayPause">
              <i ref="volumeStopPause" class="fas fa-pause"></i>
              <span class="hover-btn">{{
                $t("video_player.start_pauza")
              }}</span>
            </button>
            <button class="volume" @click="volumeNot">
              <i ref="volumeIcon" class="fas fa-volume"></i>
              <span class="hover-btn">{{ $t("video_player.volume") }}</span>
            </button>
            <input
              class="volume-range"
              :style="{
                background: `linear-gradient(to right, #ffffff 0% , #ffffff ${
                  volumeValue == null ? 50 : volumeValue * 100
                }%  , #595959 0%, #595959 100%)`,
              }"
              v-model="volumeValue"
              type="range"
              min="0"
              max="1"
              step="0.05"
            />
            <text class="time-range" ref="timeRange"
              >{{ handleHms(currentTime) }} / {{ handleHms(duration) }}</text
            >
          </span>
          <span>
            <button class="pul" @click="handlePul">
              <i class="fas fa-chalkboard"></i>
              <span class="hover-btn">
                {{ $t("video_player.mini_screen") }}</span
              >
            </button>
            <button ref="fullBtn" class="full-screen" @click="handleFullscreen">
              <i class="fas fa-expand"></i>
              <span class="hover-btn">{{
                $t("video_player.full_screen")
              }}</span>
            </button>
          </span>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
export default {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
      required: true,
    },
  },
  setup() {
    const player = ref(null);
    const volumeStopPause = ref(null);
    const timeRange = ref(null);
    const volumeValue = ref(null);
    const volumeIcon = ref(null);
    const videoRangeValue = ref(0);
    const videoPlayer = ref(null);
    const navbar = ref(null);
    const duration = ref(null);
    const currentTime = ref(0);
    const spinner = ref(null);
    const fullBtn = ref(null);
    const playVideo = ref(null);

    let overlayTimeout;
    let runvideo = 0;
    const handleOverlay = () => {
      if (typeof window !== 'undefined') {
        if (runvideo !== 0) {
          videoPlayer.value.style.cursor = "default";
          navbar.value.style.opacity = "1";
          if (overlayTimeout) clearTimeout(overlayTimeout);
          overlayTimeout = setTimeout(() => {
            videoPlayer.value.style.cursor = "none";
            navbar.value.style.opacity = "0";
          }, 2000);
        }
      }
    };

    const handleHms = (d) => {
      const h = Math.floor(d / 3600);
      const m = Math.floor((d % 3600) / 60);
      const s = Math.floor((d % 3600) % 60);

      if (h !== 0) {
        return (
          ("0" + h).slice(-2) +
          ":" +
          ("0" + m).slice(-2) +
          ":" +
          ("0" + s).slice(-2)
        );
      } else {
        return ("0" + m).slice(-2) + ":" + ("0" + s).slice(-2);
      }
    };

    const volumeChange = () => {
      player.value.volume = volumeValue.value;
      if (volumeValue.value == null) {
        player.value.volume = 0.5;
      }
      if (volumeValue.value > 0.75) {
        volumeIcon.value.classList = "fas fa-volume-up";
      } else if (volumeValue.value < 0.75 && volumeValue.value > 0.5) {
        volumeIcon.value.classList = "fas fa-volume";
      } else if (volumeValue.value < 0.5 && volumeValue.value != 0) {
        volumeIcon.value.classList = "fas fa-volume-down";
      } else if (volumeValue.value == 0) {
        volumeIcon.value.classList = "fas fa-volume-mute";
      }
    };

    const playVideoClick = () => {
      if (runvideo == 0) {
        navbar.value.style.opacity = "1";
        playVideo.value.style.display = "none";
        player.value.play();
      }
      runvideo = 1;
    };

    const volumeNot = () => {
      if (volumeValue.value == 0) {
        volumeValue.value = 0.5;
        player.value.volume = 0.5;
        volumeIcon.value.classList = "fas fa-volume-down";
      } else {
        volumeValue.value = 0;
        player.value.volume = 0;
        volumeIcon.value.classList = "fas fa-volume-mute";
      }
    };

    const handleFullscreen = () => {
      screen.orientation.lock("landscape-primary");
      const elem = videoPlayer.value;
      // const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    };

    const updateVideoInfo = () => {
      try {
        duration.value = player.value.duration;
        currentTime.value = player.value.currentTime;
        videoRangeValue.value = (100 * currentTime.value) / duration.value;

        if (player.value.play) {
          spinner.value.style.display = "none";
        } else {
          spinner.value.style.display = "inset";
        }
      } catch {
        console.log("err");
      }
    };

    const handlePlayPause = () => {
      if (runvideo !== 0) {
        player.value.paused ? player.value.play() : player.value.pause();

        volumeStopPause.value.className = "fas fa-pause";

        if (player.value.paused) {
          volumeStopPause.value.className = "fas fa-play";
        }
      }
    };

    const videoSelect = () => {
      try {
        player.value.currentTime =
          (videoRangeValue.value * player.value.duration) / 100;
      } catch {
        console.log("err");
      }
    };

    const handlePul = () => {
      if (!document.pictureInPictureElement) {
        player.value.requestPictureInPicture().catch((error) => {
          // Video failed to enter Picture-in-Picture mode.
          console.log(error);
        });
      } else {
        document.exitPictureInPicture().catch((error) => {
          // Video failed to leave Picture-in-Picture mode.
          console.log(error);
        });
      }
    };

    onMounted(() => {
      handlePlayPause();
      volumeChange();
      player.value.pause();
    });

    watch(volumeValue, () => {
      volumeChange();
    });

    onBeforeUnmount(() => {
      document.exitPictureInPicture();
    });

    return {
      player,
      volumeStopPause,
      volumeValue,
      timeRange,
      volumeChange,
      volumeIcon,
      volumeNot,
      duration,
      currentTime,
      videoRangeValue,
      handleOverlay,
      videoPlayer,
      navbar,
      handleHms,
      updateVideoInfo,
      spinner,
      videoSelect,
      handleFullscreen,
      fullBtn,
      playVideoClick,
      playVideo,
      handlePlayPause,
      handlePul,
    };
  },
};
</script>
<style lang="scss" scoped>
.play-btn {
  color: #fff;
  font-size: 1.625em;
  padding: 0.22em 1.2em;
  position: absolute;
  border: 1px solid #fff;
  transition: all 0.4s ease, border 0s;
  z-index: 100;

  &:hover {
    color: #121212;
    background-color: #fff;
    border: none;
  }
}

.video-player {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;

  .spinner-holder {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 10;
    pointer-events: none;
  }

  .video-block {
    width: 100%;
    height: 100%;
    position: relative;

    .video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .navbar {
      opacity: 0;
      transition: all 1s;
      position: absolute;
      width: 100%;
      height: 5.5em;
      bottom: 0;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.15) 0%,
        rgba(0, 0, 0, 0.75) 100%
      );
      display: flex;
      flex-direction: column;
      align-items: center;
      .video-range {
        width: 98%;
        height: 0.35em;
        -webkit-appearance: none;
        outline: none;
        border-radius: 14px;
        cursor: pointer;
        transition: all 0.6s;
        margin-bottom: 0.5em;
        &[type="range"]::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 14px;
          height: 14px;
          border-radius: 10px;
          box-sizing: content-box;
          background: white;
        }
      }
      .nav-btn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        span {
          display: flex;
          align-items: center;
          button {
            cursor: pointer;
            padding: 1em 1.5em 1em 1.5em;
            background-color: inherit;
            position: relative;
            i {
              min-width: 1.1em;
              font-size: 2.2em;
              color: rgb(255, 255, 255);
            }
            .hover-btn {
              position: absolute;
              top: -55px;
              bottom: 20em;
              padding: 15px 10px;
              background: rgba(18, 18, 18, 0.8);
              color: #ffffff;
              border-radius: 5px;
              opacity: 0;
              transition: all 0.4s;
              white-space: nowrap;
              transform: translateX(-50%);
              left: 50%;
            }
            &:hover .hover-btn {
              opacity: 1;
            }
          }
          .volume-range {
            width: 5em;
            height: 0.15em;
            -webkit-appearance: none;
            outline: none;
            border-radius: 13px;
            cursor: pointer;
            transition: all 0.6s;
            &[type="range"]::-webkit-slider-thumb {
              -webkit-appearance: none;
              width: 13px;
              height: 13px;
              border-radius: 10px;
              box-sizing: content-box;
              background: white;
            }
          }
          .stop-pause {
            margin-left: 2em;
          }
          .full-screen {
            margin-right: 2em;
          }
          .time-range {
            position: absolute;
            left: 14em;
            font-size: 1.4em;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .video-block {
    .navbar {
      height: 4.5em !important;
      .video-range {
        margin-bottom: 0.2em !important;
      }
      .nav-btn {
        span {
          .pul {
            display: none !important;
          }
          button {
            padding: 1em 1em 1em 1em !important;
            position: relative;
            i {
              min-width: 0.9em !important;
              font-size: 1.7em !important;
            }
          }
          .time-range {
            left: 13em !important;
            font-size: 1.2em !important;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .video-block {
    display: flex !important;
    align-items: center !important;
    .navbar {
      height: 100% !important;
      bottom: auto !important;
      justify-content: center !important;
      .video-range {
        position: absolute;
        margin-bottom: 1em !important;
        bottom: 0 !important;
      }
      .nav-btn {
        height: 100% !important;
        justify-content: center !important;
        span {
          .pul {
            display: none !important;
          }
          .volume {
            display: none !important;
          }
          .volume-range {
            display: none !important;
          }
          .time-range {
            left: 1em !important;
            bottom: 2.5em !important;
            font-size: 1.25em !important;
          }
          .stop-pause {
            margin-left: 0em !important;
            z-index: 100 !important;
            i {
              font-size: 4.5em !important;
            }
          }
          .full-screen {
            position: absolute !important;
            bottom: 2em !important;
            right: 0 !important;
            margin-right: 1em !important;
          }
          button {
            padding: 1em 0.75em 1em 0.75em !important;
            i {
              min-width: 0.9em !important;
              font-size: 1.7em !important;
            }
            .hover-btn {
              display: none !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 400px) {
  .video-block {
    .navbar {
      .nav-btn {
        span {
          .time-range {
            bottom: 2.2em !important;
          }
          .stop-pause {
            i {
              font-size: 4em !important;
            }
          }
          .full-screen {
            bottom: 1.4em !important;
          }
        }
      }
    }
  }
}
</style>
